import script from "./UnidadeInspecaoForm_13.vue?vue&type=script&setup=true&lang=js"
export * from "./UnidadeInspecaoForm_13.vue?vue&type=script&setup=true&lang=js"

import "./UnidadeInspecaoForm_13.vue?vue&type=style&index=0&id=602c73b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-602c73b7"]])

export default __exports__